import { Theme } from '@theme/base';
import { boxShadowMixins } from '@styles/mixins';

export const dropDownStyles = (theme: Theme) => ({
  control: (base: any, { isFocused }) => ({
    ...base,
    borderRadius: 0,
    borderLeft: 0,
    borderRight: 0,
    borderTop: 0,
    ['&:focus, &:hover, &:active']: {
      borderColor: theme.custom.colors.group7.base,
      boxShadow: 'none'
    },
    ...(isFocused && {
      borderColor: theme.custom.colors.group7.base,
      boxShadow: 'none'
    })
  }),
  valueContainer: (base: any) => ({
    ...base,
    cursor: 'pointer',
    justifyContent: 'center'
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    cursor: 'pointer'
  }),
  menu: (base: any) => ({
    ...base,
    boxShadow: boxShadowMixins(theme.custom.colors.group10.dark).glow,
    marginTop: 0
  }),
  option: (base: any, { isSelected }) => ({
    ...base,
    cursor: 'pointer',
    ...(isSelected && {
      backgroundColor: theme.custom.colors.white,
      color: theme.custom.states.selected.dark
    }),
    ['&:hover']: {
      backgroundColor: theme.custom.colors.group1.lighter
    }
  })
});
